var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail",style:({ backgroundImage: _vm.thumbnailStyle })})
}
var staticRenderFns = []

export { render, staticRenderFns }